import React from 'react';
import PropTypes from 'prop-types';

const Loader = ({ showLoader, className = '' }) => {
  if (!showLoader) return;
  return <div data-testid="loader" className={`vve-common-loader ${className}`}></div>;
};

Loader.propTypes = {
  showLoader: PropTypes.bool,
  className: PropTypes.string
};

export default Loader;
